import React, { useState, useEffect, useRef } from "react";

const testimonials = [
  {
    name: "Amanda K.",
    company: "FastMove Co.",
    rating: 5,
    comment: "Everything was smooth and fast! Highly recommended.",
    avatar: "https://i.pravatar.cc/40?img=32",
  },
  {
    name: "Michael B.",
    company: "Pro Movers",
    rating: 4,
    comment: "Great service, friendly team. A few items arrived late.",
    avatar: "https://i.pravatar.cc/40?img=44",
  },
  {
    name: "Sarah L.",
    company: "SafeHaul Ltd.",
    rating: 5,
    comment: "Best moving experience I’ve ever had. Thank you!",
    avatar: "https://i.pravatar.cc/40?img=24",
  },
];

const StarRating = ({ rating }: { rating: number }) => {
  return (
    <div className="flex gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <svg
          key={i}
          className={`w-4 h-4 ${
            i < rating ? "text-yellow-400" : "text-gray-300"
          }`}
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.212 3.726h3.917c.969 0 1.371 1.24.588 1.81l-3.165 2.3 1.212 3.726c.3.921-.755 1.688-1.538 1.118l-3.165-2.3-3.165 2.3c-.783.57-1.838-.197-1.538-1.118l1.212-3.726-3.165-2.3c-.783-.57-.38-1.81.588-1.81h3.917L9.05 2.927z" />
        </svg>
      ))}
    </div>
  );
};

const TestimonialsSection: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const currentSection = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="py-12 bg-gray-50">
      <div className="container">
        <h2
          className={`text-2xl font-bold text-center mb-8 transition-all duration-700 ${
            isVisible
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-10"
          }`}
        >
          What Customers Say
        </h2>
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className={`bg-white p-6 rounded-lg shadow hover:shadow-md transition-all duration-700 ${
                isVisible
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-10"
              }`}
              style={{ transitionDelay: `${i * 150}ms` }}
            >
              <div className="flex items-center gap-3 mb-3">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full"
                />
                <div>
                  <p className="font-semibold">{t.name}</p>
                  <p className="text-xs text-gray-500">{t.company}</p>
                </div>
              </div>
              <StarRating rating={t.rating} />
              <p className="mt-3 text-gray-700 text-sm">“{t.comment}”</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
